import { Env } from '@quirion/utils';

/**
 * Get app mode from environment variables
 * @default Env.Development
 * @returns Env
 */
export const getAppMode = (): Env =>
  import.meta.env.VITE_APP_MODE || Env.Development;
